import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../services/api";

export const fetchChatbots = createAsyncThunk(
  "chatbot/fetchChatbots",
  async (_, { rejectWithValue }) => {
    try {
      return await api.get("/chatbots");
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const chatbotSlice = createSlice({
  name: "chatbot",
  initialState: {
    chatbots: [],
    selected: null,
    loading: false,
    error: null,
  },
  reducers: {
    selectChatbot: (state, action) => {
      state.selected = action.payload;
    },
    clearChatbots: (state) => {
      state.chatbots = [];
      state.selected = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChatbots.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchChatbots.fulfilled, (state, action) => {
        state.loading = false;
        state.chatbots = action.payload || [];
        state.selected = state.selected
          ? (action.payload || []).find((c) => c.id === state.selected.id) || action.payload?.[0] || null
          : action.payload?.[0] || null;
      })
      .addCase(fetchChatbots.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { selectChatbot, clearChatbots } = chatbotSlice.actions;
export default chatbotSlice.reducer;
